class DexieMock {
    dbName: string;

    static delete(dbName: string): void {

    }

    constructor(dbName: string) {
        this.dbName = dbName;
    }

    version(num: number): DexieMock {
        return this;
    }

    stores(tableMap: FreeObjMap): void {
        for(let tableName in tableMap) {
            this[tableName] = new Table();
        }
    }
};

class Table {
    tableData: Array<FreeObjMap>;
    queryKey: FreeObjMap;
    queryValue: any;

    constructor() {
        this.tableData = [];
    }

    put(data: FreeObjMap): Promise<void> {
        return new Promise<void>((resolve: () => void, reject: () => void): void => {
            this.tableData.push(data);
            resolve();
        });
    }

    bulkPut(dataList: Array<FreeObjMap>): Promise<void> {
        return new Promise<void>((resolve: () => void, reject: () => void): void => {
            dataList.forEach((data: FreeObjMap): void => {
                this.tableData.push(data);
            });
            resolve();
        });
    }

    where(query: FreeObjMap): Table {
        this.queryKey = query;

        return this;
    }

    toArray(): Promise<FreeObjMap[]> {
        return new Promise<FreeObjMap[]>((resolve: (res: FreeObjMap[]) => void, reject: () => void): void => {
            let result: FreeObjMap[] = [];

            for(let i = 0; i < this.tableData.length; i++) {
                if (this.tableItemIsEqual(this.tableData[i], this.queryKey)) {
                    result.push(this.tableData[i]);
                }
            }

            resolve(result);
        });
    }

    delete(): Promise<void> {
        return new Promise<void>((resolve: () => void, reject: () => void): void => {
            let result: FreeObjMap[] = [];

            for(let i = 0; i < this.tableData.length; i++) {
                if (this.tableItemIsEqual(this.tableData[i], this.queryKey)) {
                    this.tableData.splice(i, 1);
                    i--;
                }
            }

            resolve();
        });
    }

    tableItemIsEqual(item: FreeObjMap, map: FreeObjMap) {
        for (let key in map) {
            if (item[key] !== map[key]) {
                return false;
            }
        }

        return true;
    }

    clear(): Promise<void> {
        return new Promise<void>((resolve: () => void, reject: () => void): void => {
            this.tableData.length = 0;
            resolve();
        });
    }

    count(): Promise<number> {
        return new Promise<number>((resolve: (num: number) => void, reject: () => void): void => {
            resolve(this.tableData.length);
        });
    }

    modify(updateData: FreeObjMap): Promise<void> {
        return new Promise<void>((resolve: () => void, reject: () => void): void => {
            let result: FreeObjMap[] = [];

            for(let i = 0; i < this.tableData.length; i++) {
                if (this.tableItemIsEqual(this.tableData[i], this.queryKey)) {
                    for (let key in updateData) {
                        this.tableData[i][key] = updateData[key];
                    }
                }
            }

            resolve();
        });
    }
}

export default DexieMock;
